// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2VB3A","hidden":"_12Mmd","row-wrapper":"_2z3r1","cancel-btn-div":"_2e-t8","cancel-btn":"QUhIo","content-wrapper":"_3rAXq"};